// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3216":"8974eae0","4832":"8974eae0","6152":"8974eae0","6248":"8974eae0","6896":"8974eae0","9892":"8974eae0"}[chunkId] + ".chunk.css";
};